import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col, Button, Spinner } from 'reactstrap';
import Navbar from '../NavBar/navBar';
import RiskKPIs from '../RiskDashboard/riskKPIs';
import RiskHeatMap from '../RiskHeatMap/riskHeatMap';
import Axios from '../../apis/nodeServer';
import { fetchFloors, fetchBuilding } from '../../actions';
import { withTranslation } from 'react-i18next';
import './riskManagementPage.css';

class RiskManagementPage extends Component {
    state = {
        calculating: false,
        lastCalculation: null,
        selectedFloorId: null
    };

    handleFloorChange = (floorId) => {
        this.setState({ selectedFloorId: floorId });
    };

    componentDidMount() {
        // Carregar dados necessários
        if (this.props.fetchFloors) {
            this.props.fetchFloors();
        }
        if (this.props.fetchBuilding) {
            this.props.fetchBuilding();
        }
    }

    handleCalculateRisks = async () => {
        this.setState({ calculating: true });
        
        try {
            await Axios.instance.post('risk/calculate/');

            this.setState({
                calculating: false,
                lastCalculation: new Date().toLocaleString()
            });
            
            // Recarregar os componentes
            window.location.reload();
        } catch (error) {
            console.error('Error calculating risks:', error);
            this.setState({ calculating: false });
        }
    };

    render() {
        const { calculating, lastCalculation } = this.state;
        const { t } = this.props;

        return (
            <>
                <Navbar />
                <div className="risk-management-page">
                    <Container fluid>
                        {/* Header com título e ações */}
                        <Row className="page-header mb-4">
                            <Col md={6}>
                                <h2 className="page-title">
                                    🔬 {t('riskManagement.title')}
                                </h2>
                                <p className="page-subtitle">
                                    {t('riskManagement.subtitle')}
                                </p>
                            </Col>
                            <Col md={6} className="text-right">
                                <Button 
                                    color="success" 
                                    size="lg"
                                    onClick={this.handleCalculateRisks}
                                    disabled={calculating}
                                    className="calculate-btn"
                                >
                                    {calculating ? (
                                        <>
                                            <Spinner size="sm" className="mr-2" />
                                            {t('common.loading')}
                                        </>
                                    ) : (
                                        <>
                                            🔄 {t('riskManagement.generateReport')}
                                        </>
                                    )}
                                </Button>
                                {lastCalculation && (
                                    <div className="last-calculation mt-2">
                                        {t('dashboard.lastUpdated')}: {lastCalculation}
                                    </div>
                                )}
                            </Col>
                        </Row>

                        {/* KPIs Dashboard */}
                        <Row className="mb-4">
                            <Col>
                                <div className="section-card">
                                    <RiskKPIs floorId={this.state.selectedFloorId} />
                                </div>
                            </Col>
                        </Row>

                        {/* Heat Map */}
                        <Row className="mb-4">
                            <Col>
                                <div className="section-card">
                                    <RiskHeatMap
                                        floorsList={this.props.floorsList}
                                        fetchFloors={this.props.fetchFloors}
                                        onFloorChange={this.handleFloorChange}
                                    />
                                </div>
                            </Col>
                        </Row>

                        {/* Info Footer */}
                        <Row className="mt-4">
                            <Col>
                                <div className="info-panel">
                                    <h5>📊 {t('riskManagement.kpis')}</h5>
                                    <p>
                                        {t('riskManagement.subtitle')}
                                    </p>
                                    <p className="text-muted">
                                        <span className="badge badge-success ml-2">{t('riskManagement.lowRisk')}</span>
                                        <span className="badge badge-warning ml-2">{t('riskManagement.mediumRisk')}</span>
                                        <span className="badge badge-danger ml-2">{t('riskManagement.highRisk')}</span>
                                    </p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        floorsList: state.floorsListReducer,
        buildingList: state.buildingListReducer
    };
};

export default connect(mapStateToProps, { 
    fetchFloors,
    fetchBuilding
})(withTranslation()(RiskManagementPage));

